/* Site-Specific JavaScript */

// Wrap the "~" (approximation) symbol inside .stat--value in a .approx span so
// it can be nudged into vertical alignment via CSS (.approx { top: -0.1em; }).
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.stat--value').forEach(function (el) {
        if (el.querySelector('.approx')) return; // already processed

        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        var textNodes = [];
        var node;
        while ((node = walker.nextNode())) {
            if (node.nodeValue.indexOf('~') !== -1) {
                textNodes.push(node);
            }
        }

        textNodes.forEach(function (textNode) {
            var frag = document.createDocumentFragment();
            textNode.nodeValue.split('~').forEach(function (part, i) {
                if (i > 0) {
                    var span = document.createElement('span');
                    span.className = 'approx';
                    span.textContent = '~';
                    frag.appendChild(span);
                }
                if (part) {
                    frag.appendChild(document.createTextNode(part));
                }
            });
            textNode.parentNode.replaceChild(frag, textNode);
        });
    });
});
